import * as React from "react"
import {useAppSelector} from "../../redux/storeHooks";

const MemberNameAndAvatar = () => {

  const userName:string = useAppSelector((store) => store.loginState.userName);
  const showAdditionalText = true;

  return (
    <section className="section">
      <div className="container">
        <span className="block h5 text-center red2 margin-b-15">Content Marketing Services</span>
        <h2 className="h2 text-center black max-620 auto margin-b-50">Hi, {userName}</h2>
        <div className="flex flex--column-book">
          <div className="flex-item col col--big">
            <div className="assistant flex max-620 auto">
              <div className="flex-item assistant-avatar">
                <img src="images/member/assistant.png" alt="" />
              </div>
              <div className="flex-item assistant-text">
                <span className="h4 margin-b-15 block bold">My Name Is Sonia...</span>
                <p className="margin-0">...and I am your Personal Profile Manager & Stories Maker!</p>
              </div>
            </div>
          </div>
          {showAdditionalText ? (
            <div className="flex-item col col--big">
              <p className="card-text">
                I'll reach out to you shortly to discuss all the particulars of your marketing plan. You're just a few steps away from boosting your account!
              </p>
              <p className="card-text">
                In the meantime, please take a moment to provide some information about yourself and your objectives for our upcoming collaboration on your promotional efforts.
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default MemberNameAndAvatar
